import React from 'react';

/*eslint-disable */

var plusIcon = (function (_ref) {
  var alt = _ref.alt;
  return /*#__PURE__*/React.createElement("svg", {
    width: "20px",
    height: "20px",
    focusable: "false",
    viewBox: "0 0 20 20",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, alt), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "0",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    fillRule: "nonzero",
    points: "20 9 20 11 0 11 0 9"
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "nonzero",
    points: "9 0 11 0 11 20 9 20"
  })));
});

export { plusIcon as default };
